import AjaxManager from "../ajaxManager";

var SendBudget = function () {

    "use strict";

    var self = this;
    this.ajaxManager = new AjaxManager();

    this.initialize = function () {
        this.eventDelegation();
    };

    this.eventDelegation = function () {
        $("[data-action=send-budget]").click(function () {
            $('#sendBudgetForm').data('formValidation').validate();
        });
        $("[data-action=re-send-budget]").click(function () {
            self.reSend();
        });

        const sendBudgetButtons = document.querySelectorAll('[data-action="share"]');
        if (sendBudgetButtons) {
            sendBudgetButtons.forEach(function (sendBudgetButton) {
                sendBudgetButton.addEventListener('click', function (e) {
                    const shareData = {
                        title: e.currentTarget.getAttribute('data-web'),
                        text: e.currentTarget.getAttribute('data-title'),
                        url: document.location.href,
                    }
                    if (myApp.config.routing && myApp.config.routing.bookingSharingUrl) {
                        shareData.url = myApp.config.routing.bookingSharingUrl;
                    }

                    const isMobile = myApp.deviceDetector.isXsScreen() || myApp.deviceDetector.isSmScreen();
                    const canShare = navigator.canShare && navigator.canShare(shareData);
                    if (canShare && isMobile) {
                        navigator.share(shareData);
                    } else {
                        myApp.customModalManager.openModal('#shareModal');
                    }
                })
            })
        }
    };

    this.send = function () {
        var url, type, data, callback;
        url = myApp.config.routing.ajaxSendBudget;
        type = 'POST';
        data = {
            reserva: myApp.booking,
            nom_emisor: $('[data-budget=name]').val() + ' ' + $('[data-budget=surname]').val(),
            email_emisor: $('[data-budget=email]').val(),
            email_destinatari: $('[data-budget=friendemail]').val(),
            mensaje: $('[data-budget=message]').val()
        };
        callback = function callback(data) {
            let resultContainer = document.querySelector("[data-budget=result]");
            const reSendBudgetButton = document.querySelector('[data-action="re-send-budget"]');
            const budgetFormContainer = document.querySelector('[data-element="budget-form-container"]');

            if (data == 1) {
                budgetFormContainer.classList.add("d-none");
                reSendBudgetButton.classList.remove("d-none");
                $('[data-budget=result]').show().html(myApp.translator['budget.result.correct']);
                resultContainer.classList.remove("alert-danger");
                resultContainer.classList.add("alert-success");
            } else {
                $('[data-budget=result]').show().html(myApp.translator['budget.result.incorrect']);
                resultContainer.classList.remove("alert-success");
                resultContainer.classList.add("alert-danger");
            }
        };
        self.ajaxManager.ajaxCall(type, url, data, callback);
    };

    this.reSend = function () {
        const reSendBudgetButton = document.querySelector('[data-action="re-send-budget"]');
        const budgetFormContainer = document.querySelector('[data-element="budget-form-container"]');
        budgetFormContainer.classList.remove("d-none");
        reSendBudgetButton.classList.add("d-none");
        self.resetBudgetForm();
    }

    this.resetBudgetForm = function () {
        const successMessage = document.querySelector('[data-budget=result]');
        if (successMessage) {
            successMessage.classList.add('d-none');
        }
        document.querySelector('[data-budget="message"]').value = '';
        $('#sendBudgetForm').data('formValidation').resetForm(true);
    }
    this.initialize();
};

export default SendBudget;